export default __webpack_public_path__ + "static/media/task1.522cbceb.svg";